<script setup>
import { defineProps, ref, computed } from 'vue'
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'
import StringParam from '@/components/Docs/Parameters/StringParam.vue'
import EndpointBlock from '@/components/Docs/EndpointBlock.vue'

defineProps({ anchor: String })

let request_query = ref("*")
let request_field = ref("id.resp_h")
let request_format = ref("csv")
let request_filter_field = ref("")
let request_filter_value = ref("")

let request_body = computed(() => {
  const body = {
    query: request_query.value,
    field: request_field.value,
    format: request_format.value,
  }
  if (request_filter_field.value) body.filter_field = request_filter_field.value
  if (request_filter_value.value) body.filter_value = request_filter_value.value
  return body
})
</script>

<template>
  <doc-section title="Export aggregate" :anchor="anchor">
    <template v-slot:left>
      <div class="mb-5">
        <p>
          Streams aggregated <strong>value,count</strong> rows over the given
          <code>field</code> to a file rather than returning a JSON envelope. Output
          is gzipped. Up to <strong>10,000</strong> aggregated values are exported.
        </p>
        <p>
          Sources and log types are scoped to your organization's grants.
        </p>
      </div>

      <div class="mb-5">
        <h4 class="mb-4">Request parameters</h4>

        <StringParam class="mb-3" name="Query" :required="true"
          description="Query string constraining the documents to aggregate over"
          type="string" :value="request_query" @value="(v) => request_query = v" />

        <StringParam class="mb-3" name="Field" :required="true"
          description="Field to aggregate on"
          type="string" :value="request_field" @value="(v) => request_field = v" />

        <StringParam class="mb-3" name="Filter field" :required="false"
          description="Optional field to filter buckets by"
          type="string" :value="request_filter_field" @value="(v) => request_filter_field = v" />

        <StringParam class="mb-3" name="Filter value" :required="false"
          description="Optional value for the filter field"
          type="string" :value="request_filter_value" @value="(v) => request_filter_value = v" />

        <StringParam class="mb-3" name="Format" :required="false"
          description="Output format: csv (default) or jsonl"
          type="string" :value="request_format" @value="(v) => request_format = v" />
      </div>
    </template>

    <template v-slot:right>
      <endpoint-block
        title="/query/event/aggregate/export"
        method="POST"
        name="Export Aggregate"
        query="/query/event/aggregate/export"
        :body="request_body"
        :download="true"
      />

      <code-block title="Response (gzipped file)" raw>
value,count
8.8.8.8,128
1.1.1.1,74
      </code-block>
    </template>
  </doc-section>
</template>
